<template>
    <div class="overflow-x-auto">
        <table class="w-full border-collapse border border-gray-300 text-sm">
            <thead>
                <tr class="bg-gray-100 text-left">
                    <th class="border border-gray-300 p-2">STT</th>
                    <th class="border border-gray-300 p-2">DIỄN GIẢI</th>
                    <th class="border border-gray-300 p-2">SỐ TIỀN</th>
                    <th class="border border-gray-300 p-2">GHI CHÚ</th>
                </tr>
            </thead>
            <tbody>
                <!-- I. SỐ TIỀN TẠM ỨNG -->
                <tr>
                    <td colspan="2" class="border border-gray-300 p-2 font-bold">
                        I. SỐ TIỀN TẠM ỨNG: (1)
                    </td>
                    <td class="border border-gray-300 p-2">
                        <input :value="formatNumber(localValue.AdvanceMoney.money)" @input="updateMoneyTotal" @keypress="onlyNumber" class="w-full border p-1 rounded"
                            placeholder="Nhập số tiền" />
                    </td>
                    <td class="border border-gray-300 p-2">
                        <textarea v-model="localValue.AdvanceMoney.note" type="text" class="w-full border p-1 rounded"
                            placeholder="Ghi chú" />
                    </td>
                </tr>
    
                <!-- II. SỐ TIỀN ĐÃ CHI -->
                <tr>
                    <td colspan="4" class="border border-gray-300 p-2 font-bold">
                        II. SỐ TIỀN ĐÃ CHI: (2)
                    </td>
                </tr>
    
                <tr v-for="(item, index) in localValue.SpentMoney" :key="index">
                    <td class="border border-gray-300 p-2 text-center">{{ index + 1 }}</td>
                    <td class="border border-gray-300 p-2">
                        <textarea v-model="item.detail" class="min-w-[220px] w-full border p-1 rounded"
                            placeholder="Diễn giải" />
                    </td>
                    <td class="border border-gray-300 p-2">
                        <input :value="formatNumber(item.money)" @input="updateSpentMoney($event, index)" @keypress="onlyNumber" class="min-w-[150px] w-full border p-1 rounded"
                            placeholder="Số tiền" />
                    </td>
                    <td class="border border-gray-300 p-2">
                        <div class="flex flex-row">
                            <textarea v-model="item.note" type="text" class="min-w-[200px] w-full border p-1 rounded" placeholder="Ghi chú" />
                            <button v-if="localValue.SpentMoney.length > 1" class="text-red-500 font-bold ml-[10px]"
                                @click="removeRowSpentMoney(index)">
                                <font-awesome-icon :icon="['fas', 'trash-can']" />
                            </button>
                        </div>
                    </td>
                </tr>
    
                <!-- nút thêm -->
                <tr>
                    <td colspan="4" class="border border-gray-300 p-2 text-center font-bold text-blue-500 cursor-pointer"
                        @click="addRowSpentMoney">
                        <font-awesome-icon :icon="['fas', 'plus']" /> Thêm số tiền đã chi
                    </td>
                </tr>
    
                <!-- III. CHÊNH LỆCH -->
                <tr>
                    <td colspan="4" class="border border-gray-300 p-2 font-bold">
                        III. CHÊNH LỆCH
                    </td>
                </tr>
                <tr>
                    <td class="border border-gray-300 p-2 text-center">1</td>
                    <td class="border border-gray-300 p-2">Số tạm ứng chi không hết (I - II)</td>
                    <td class="border border-gray-300 p-2">
                        <input class="w-full border rounded p-1 text-sm text-right" :value="checkNegative(localValue.AdvanceMoney.money - totalSpent)" :disabled="true"/>
                    </td>
                    <td class="border border-gray-300 p-2">
                        <textarea v-model="localValue.noteRemainingAdvance" type="text" class="w-full border p-1 rounded"
                            placeholder="Ghi chú" />
                    </td>
                </tr>
                <tr>
                    <td class="border border-gray-300 p-2 text-center">2</td>
                    <td class="border border-gray-300 p-2">Chi quá số tạm ứng (II - I)</td>
                    <td class="border border-gray-300 p-2">
                        <input class="w-full border rounded p-1 text-sm text-right" :value="checkNegative(totalSpent - localValue.AdvanceMoney.money)" :disabled="true"/>
                    </td>
                    <td class="border border-gray-300 p-2">
                        <textarea v-model="localValue.noteExcessAdvance" type="text" class="w-full border p-1 rounded"
                            placeholder="Ghi chú" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { onlyNumber, formatNumber, unformatNumber } from '@/utils/onlyNum';
export default {
    props: {
        value: { // v-model trong Vue 2 map vào prop "value"
            type: Object,
            required: true
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val); // emit ngược lên cha
            }
        },
        totalSpent() {
            return this.localValue.SpentMoney.reduce((sum, item) => {
                return sum + (Number(item.money) || 0);
            }, 0);
        }
    },
    methods: {
        onlyNumber,
        formatNumber,
        updateMoneyTotal(e) {
            this.localValue.AdvanceMoney.money = unformatNumber(e.target.value)
        },
        updateSpentMoney(e, index) {
            this.localValue.SpentMoney[index].money = unformatNumber(e.target.value)
        },
        checkNegative(value) {
            return value < 0 ? 0 : formatNumber(value)
        },
        addRowSpentMoney() {
            const newSpent = [...this.localValue.SpentMoney, { detail: "", money: 0, note: "" }];
            this.localValue = {
                ...this.localValue,
                SpentMoney: newSpent
            };
        },
        removeRowSpentMoney(index) {
            const newSpent = this.localValue.SpentMoney.filter((_, i) => i !== index);
            this.localValue = {
                ...this.localValue,
                SpentMoney: newSpent
            };
        }
    }
}
</script>
